import { Fragment, type ReactNode, createElement } from "react"

type TEmptyCallback = () => void

const emptyCallback: TEmptyCallback = (): void => void 0

type TEmptyAsyncCallback = () => Promise<void>

const emptyAsyncCallback: TEmptyAsyncCallback = async (): Promise<void> => void 0

type TEmptyRenderCallback = () => ReactNode

const emptyRenderCallback: TEmptyRenderCallback = (): ReactNode => createElement(Fragment)

export { emptyCallback, emptyAsyncCallback, emptyRenderCallback }
export type { TEmptyCallback, TEmptyAsyncCallback, TEmptyRenderCallback }
